import React from 'react'

type IconType = (props: Partial<React.SVGProps<SVGSVGElement>>) => JSX.Element
const asIcons = <T extends unknown>(et: { [K in keyof T]: IconType }) => et

export const Icons = asIcons({
  Play: props => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path d="M3 1.14v14l11-7z" />
    </svg>
  ),
  ErrorOutline: props => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      baseProfile="full"
      width="24"
      height="24"
      viewBox="0 0 24.00 24.00"
      {...props}>
      <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
    </svg>
  ),
  Link: props => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      baseProfile="full"
      width="24"
      height="24"
      viewBox="0 0 24.00 24.00"
      {...props}>
      <path d="M10.586 13.414a1 1 0 0 1-1.414 1.414 5 5 0 0 1 0-7.07l3.535-3.536a5 5 0 0 1 7.071 7.071l-1.485 1.486a7.017 7.017 0 0 0-.405-2.424l.476-.476a3 3 0 1 0-4.243-4.243l-3.535 3.536a3 3 0 0 0 0 4.242zm2.828-4.242a1 1 0 0 1 1.414 0 5 5 0 0 1 0 7.07l-3.535 3.536a5 5 0 0 1-7.071-7.07l1.485-1.486a7.03 7.03 0 0 0 .405 2.423l-.476.476a3 3 0 1 0 4.243 4.243l3.535-3.536a3 3 0 0 0 0-4.242 1 1 0 0 1 0-1.414z" />
    </svg>
  ),
  Search: props => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path
        d="M13.46 12.84a7 7 0 1 0-.71.71l8.57 8.57.71-.71zm-5.28 1.42a6 6 0 1 1 6-6 6 6 0 0 1-6 6z"
        fill="#4b4f56"
      />
    </svg>
  ),
  Close: props => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path fill="none" stroke="#4b4f56" strokeMiterlimit="10" d="M2 2l12 12" />
      <path fill="none" stroke="#4b4f56" strokeMiterlimit="10" d="M14 2L2 14" />
    </svg>
  ),
})
